import { DEFAULT_LOCALE } from '@/constants/common'
import { ENTITY_TYPE } from '@/constants/entities'
import { KR_MEASURING_SYMBOL, KR_MEASURING_UNIT, KR_STATUS } from './constants/kr'

let krKey = 0 // use negative keys to distinguish them from krs with ids

export function newKRData(ownerId) {
  return {
    key: --krKey,
    title: '',
    measureBy: KR_MEASURING_UNIT.PERCENTAGE,
    ownerId,
    coOwnerIds: [],
    weight: 3,
    start: 0,
    end: 100,
    status: KR_STATUS.ON_TRACK,
    otype: ENTITY_TYPE.KEY_RESULT
  }
}

export function capitalizeString(string) {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

export function formatHyphenatedString(status) {
  return status
    .split('-')
    .map(capitalizeString)
    .join(' ')
}

export const formatNumber = (number, notation = 'standard', maximumSignificantDigits = 3) =>
  Intl.NumberFormat(DEFAULT_LOCALE, {
    notation,
    maximumSignificantDigits
  }).format(number)

export function krMeasurementText(
  measureBy,
  value,
  numberFormatNotation,
  maximumSignificantDigits = 21
) {
  const symbol = KR_MEASURING_SYMBOL[measureBy]
  if (measureBy === KR_MEASURING_UNIT.PERCENTAGE) {
    return formatNumber(value ?? 0, numberFormatNotation, maximumSignificantDigits) + symbol
  } else if (measureBy === KR_MEASURING_UNIT.MONEY) {
    return symbol + formatNumber(value, numberFormatNotation, maximumSignificantDigits)
  } else if (measureBy === KR_MEASURING_UNIT.NUMBER) {
    return formatNumber(value, numberFormatNotation, maximumSignificantDigits)
  } else if (measureBy === KR_MEASURING_UNIT.BOOLEAN) {
    return value === 0 ? 'Open' : 'Completed'
  }
}
